import {OnBaseDocumentData} from '../types/OnBaseDocumentData'

async function DeleteFailedDocument(doc: OnBaseDocumentData)
{
      try {
      
        const baseURL = process.env.REACT_APP_ONBASE_SUPPORT_API_URL;
        const endURL = '/api/DeleteFailedDocument';

        const response = await fetch(
          baseURL + endURL,
          {
            headers: {'Content-Type': 'application/json'},
            method: "POST",
            body: JSON.stringify(doc)
          }
        );

        if (response.ok) {
          console.log("Delete Document successful");
        } else {
          throw new Error('Error Deleting OnBase Document');
        }
      } catch (error) {
        console.error('Error Deleting OnBase Document:', error);
      }
    };

export default DeleteFailedDocument;